export default __webpack_public_path__ + "static/new-hero-animation02-979f38403e93fc3ae67f95bfe65444f7.mp4";